import { ChildChild, RenewalChildRecord, RenewalRecord, TaskChild } from 'models/Renewals';
import { RENEWAL_RECORD_TYPE } from 'shared/constants';
import { GanttChartMode } from 'sb/shared/constants';

const getClientContactFilteredChildren = (
  childData: RenewalChildRecord[],
  clientContactFilterValue: string | any[]
) => {
  return childData.filter(
    (childChild) =>
      childChild.recordType === RENEWAL_RECORD_TYPE.DEAL &&
      clientContactFilterValue.includes(childChild.clientContact?.Id)
  );
};

export const getClientContactFilteredTasks = (dataArray: RenewalRecord[], clientContactFilterValue: string | any[]) => {
  // create an array with the children that have selected client contacts
  const childrenFilteredMap = dataArray.map((taskChild) => {
    if (taskChild?.recordType === RENEWAL_RECORD_TYPE.SUPPLIER && taskChild?.children?.length > 0) {
      return {
        ...taskChild,
        children: getClientContactFilteredChildren(taskChild?.children, clientContactFilterValue)
      };
    } else {
      return taskChild;
    }
  });
  // filter the created array
  return childrenFilteredMap?.filter((taskChild: RenewalRecord) => {
    return (
      (taskChild?.recordType === RENEWAL_RECORD_TYPE.SUPPLIER_DEAL &&
        clientContactFilterValue.includes((taskChild as TaskChild).clientContact?.Id)) ||
      (taskChild?.recordType === RENEWAL_RECORD_TYPE.SUPPLIER &&
        taskChild?.children?.length > 0 &&
        taskChild?.children?.some((childChild: RenewalRecord) =>
          clientContactFilterValue.includes((childChild as ChildChild).clientContact?.Id)
        ))
    );
  });
};

interface FilterProps {
  clientContactFilterValue: Array<string | number>;
  _tasks: RenewalRecord[];
  selectedCategories?: Array<string | number>;
}
export const getFilteredTasks = (props: FilterProps) => {
  const { clientContactFilterValue, _tasks, selectedCategories } = props;
  if (!_tasks || !_tasks[0]) return [];

  let tasksList: RenewalRecord[] = _tasks[0]?.children;

  // Apply client contact filter first
  if (clientContactFilterValue?.length > 0) {
    tasksList = getClientContactFilteredTasks(tasksList, clientContactFilterValue);
  }

  // Apply category filter to already-filtered results
  if (selectedCategories && selectedCategories.length > 0) {
    tasksList = getCategoryFilteredTasks(tasksList, selectedCategories);
  }

  return tasksList;
};

const getCategoryFilteredTasks = (
  dataArray: RenewalRecord[],
  selectedCategories: Array<string | number>
): RenewalRecord[] => {
  const filteredDataArray: RenewalRecord[] = [];

  dataArray.forEach((record) => {
    const recordMatchesCategory =
      (record as any).contract_category &&
      (record as any).contract_category.some((recordCat: any) => {
        const rootMatch = selectedCategories.some((selectedCat: any) => {
          if (Array.isArray(selectedCat)) {
            const [root, prime, second] = selectedCat.map(String);
            if (root !== recordCat.category_root_name?.toString()) return false;
            if (prime && prime !== recordCat.category_prime_name?.toString()) return false;
            if (
              second &&
              !(recordCat.category_second || []).some((s: any) => s.category_second_name?.toString() === second)
            )
              return false;
            return true;
          } else {
            return selectedCat === recordCat.category_root_name?.toString();
          }
        });
        return rootMatch;
      });

    if (record.children && record.children.length > 0) {
      const filteredChildren = record.children.filter((child) => {
        if (
          child.contract_category &&
          child.contract_category.some((childCat: any) => {
            return selectedCategories.some((selectedCat: any) => {
              if (Array.isArray(selectedCat)) {
                const [root, prime, second] = selectedCat.map(String);
                if (root !== childCat.category_root_name?.toString()) return false;
                if (prime && prime !== childCat.category_prime_name?.toString()) return false;
                if (
                  second &&
                  !(childCat.category_second || []).some((s: any) => s.category_second_name?.toString() === second)
                )
                  return false;
                return true;
              } else {
                return selectedCat === childCat.category_root_name?.toString();
              }
            });
          })
        ) {
          return true;
        }
        return false;
      });

      // Include record if it matches category OR if it has matching children
      if (recordMatchesCategory || filteredChildren.length > 0) {
        filteredDataArray.push({
          ...record,
          children: recordMatchesCategory ? record.children : filteredChildren
        });
      }
    } else {
      if (recordMatchesCategory) {
        filteredDataArray.push(record);
      }
    }
  });

  return filteredDataArray;
};
